<template>
  <div class="card">
    <header class="card-header">
      <a
        class="button is-small is-text is-loading"
        v-if="loading"
        style="margin-right: 9px"
      ></a>
      <a
        class="card-header-icon icon"
        aria-label="state"
        fa-tooltip-pos="down"
        v-bind:title="stateText"
        v-else
      >
        <span class="state-circle" :class="[state]"></span>
      </a>
      <p class="card-header-title">{{ config.appName }}</p>
      <a class="card-header-icon">
        <input
          type="checkbox"
          class="switch is-success is-rounded is-primary"
          :checked="config.enabled"
        />

        <label
          :for="'enabled-' + index"
          class="switch-btn"
          @click="handleEmit('switch')"
        ></label>
      </a>
    </header>
    <div class="card-content">
      <div class="content">
        <div class="columns is-mobile">
          <div class="column">
            <label>{{ $t("apps.localPort") }}</label>
            <p>{{ config.srcPort }}</p>
          </div>
          <div class="column">
            <label>{{ $t("apps.protocol") }}</label>
            <p>{{ config.protocol.toUpperCase() }}</p>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column" style="flex-grow: 2">
            <label>{{ $t("apps.remoteNode") }}</label>
            <p>{{ peerNode }}</p>
          </div>
          <div class="column" style="flex-grow: 2">
            <label>{{ $t("apps.remoteService") }}</label>
            <p>{{ config.dstHost + ":" + config.dstPort }}</p>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column" style="flex-grow: 2">
            <label>{{ $t("apps.link") }}</label>
            <p>{{ link(config) }}</p>
          </div>
          <div
            v-if="config.relayNode && config.relayMode"
            class="column"
            style="flex-grow: 2"
          >
            <label>{{ $t("apps.relayNode") }}</label>
            <p v-if="config.relayMode == 'public'">
              {{ $t("apps.publicNet") }}
            </p>
            <p v-if="config.relayMode != 'public'">{{ config.relayNode }}</p>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column" style="flex-grow: 2">
            <label>{{ $t("apps.connectTime") }}</label>
            <p>{{ config.connectTime }}</p>
          </div>
        </div>
        <!-- <div class="columns is-mobile">
          <div class="column">
            <label>带宽</label>
            <p>{{ +config.bandwidth || config.defaultBW || 1 }}Mbps</p>
          </div>
        </div>-->
      </div>
    </div>
    <footer class="card-footer">
      <a
        class="card-footer-item"
        style="padding-left: 0.4rem"
        @click="handleEmit('delete')"
      >
        <feather-trash class="icon"></feather-trash>
        {{ $t("delete") }}
      </a>
      <a
        class="card-footer-item"
        style="padding-left: 1rem"
        :disabled="config.recovered"
        @click="
          this.$router.push({
            path: '/appedit/' + encodeURIComponent(this.$route.params.nodeName),
            query: data,
          })
        "
      >
        <feather-edit class="icon"></feather-edit>
        {{ $t("edit") }}
      </a>
    </footer>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
export default {
  name: "appCard",

  components: {},

  props: {
    data: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      config: this.data,
      peerNode: "",
    }
  },

  computed: {
    state() {
      return this.config.isActive == 1 ? "on" : "off"
    },
    stateText() {
      return this.config.isActive == 1
        ? this.$t("connectOK")
        : this.$t("connectError")
    },
  },

  beforeMount() {
    // window.debugLog('config', this.data)
  },
  mounted() {
    this.$data.peerNode = this.$data.config.peerNode
    if (!this.$store.state.nodes) return
    let data = this.$store.state.nodes.filter(
      (node) => node.name == this.$data.config.peerNode
    )
    if (!data[0].isActive)
      this.$data.peerNode += " (" + this.$t("offline") + ")"
  },
  methods: {
    async handleEmit(action) {
      let res = null
      switch (action) {
        case "delete":
          window.debugLog(this.config.appName, " delete")
          res = await axios.post(
            this.$ServerHost +
              "/api/v1/device/" +
              encodeURIComponent(this.$route.params.nodeName) +
              "/app",
            {
              appName: this.config.appName,
              protocol0: this.config.protocol, //protocol0+srcPort0 is the p2papp's id
              srcPort0: +this.config.srcPort,
              peerNode: this.config.peerNode,
              dstHost: this.config.dstHost,
              dstPort: +this.config.dstPort,
            }
          )
          window.debugLog(res)
          if (res && res.status == 200) {
            let newApps = this.$store.state.apps.filter(
              (app) => app.appName != this.config.appName
            )
            this.$store.commit("setApps", newApps)
            weui.alert(this.config.appName + this.$t("deleteOK"), {
              buttons: [
                {
                  label: this.$t("ok"),
                },
              ],
            })
          } else
            weui.alert(this.config.appName + this.$t("deleteError"), {
              buttons: [
                {
                  label: this.$t("ok"),
                },
              ],
            })

          // this.$router.go(0);
          break
        case "switch":
          this.config.enabled ^= 1
          window.debugLog(
            this.config.appName,
            " switch to ",
            this.config.enabled
          )
          res = await axios.post(
            this.$ServerHost +
              "/api/v1/device/" +
              encodeURIComponent(this.$route.params.nodeName) +
              "/switchapp",
            {
              appName: this.config.appName,
              protocol: this.config.protocol,
              srcPort: +this.config.srcPort,
              enabled: this.config.enabled,
            }
          )
          window.debugLog(res)
          break
        default:
          return
      }
    },
    link(config) {
      window.debugLog("link:", config)
      if (config.enabled != 1) return this.$t("apps.disabled")
      if (config.isActive != 1) {
        return this.$t("apps.connecting")
      } else if (config.relayMode == "public") {
        return this.$t("apps.relay")
      } else if (config.relayMode == "private") {
        return this.$t("apps.relay") + " (" + this.$t("apps.privateNet") + ")"
      } else {
        if (config.linkMode == "ipv6") {
          // ignore ipv4
          return this.$t("apps.directIPv6")
        }
        return this.$t("apps.direct")
      }
    },
  },
}
</script>




<style lang="scss">
@import "../../assets/css/card.scss";
</style>

